import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { useMemo, useState } from "react";
import { metadataStringify, parseJson } from "../../../utils/utils";

import styles from "./CustomReportsCondition.module.sass";
import { Dropdown, RegularButton, TextInput } from "colbi_web_ui/lib/components/inputs";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";

const filterOperators = [
    { id: "equals", name: "equals" },
    { id: "differs", name: "differs" },
    { id: "greater", name: "greater" },
    { id: "greater or equals", name: "greater or equals" },
    { id: "less", name: "less" },
    { id: "less or equals", name: "less or equals" },
    { id: "between", name: "between" },
    { id: "not between", name: "not between" },
    { id: "like", name: "like" },
    { id: "not like", name: "not like" },
    { id: "starts with", name: "starts with" },
    { id: "not starts with", name: "not starts with" },
    { id: "in", name: "in" },
    { id: "not in", name: "not in" },
];

const CustomReportCondition = ({ DefaultCondition, Metadata, handleChange, negationName="", setNegationName = null, attributeName, isToShowNegation = false, isToShowConditionsFieldds = false, isToKeepOldLabes = false }) => {
    const [parsedConditionFields, setParsedConditionFields] = useState([]);
    const [columnsConfiguration, setColumnsConfiguration] = useState([]);
    const [showNegationContainer, setShowNegationContainer] = useState(isToShowNegation || false);
    const { i18n } = useGlobalValue();

    let parsedConditions = JSON.parse(DefaultCondition || "[]");
    const parsedConditionsIsArray = Array.isArray(parsedConditions);

    let conditionsFields = [];

    if (parsedConditionFields && parsedConditionFields.length) {
        let filterdConditionFields = parsedConditionFields || [];
        filterdConditionFields = filterdConditionFields.filter(
            (field) => field && field !== "" && field.trim().length > 0,
        );

        conditionsFields = (filterdConditionFields || []).map((elem) => {
            return {
                id: elem,
                name: elem,
            };
        });
    }

    const betweenOperatorInputs = (filterValue, elem) => {
        const filterBetween = filterValue.split("#");
        return (
            <>
                <TextInput
                    className={styles["input"]}
                    name={i18n`Condition From`}
                    placeholder={i18n`Enter a Condition From`}
                    value={filterBetween[0] || ""}
                    required
                    onChange={(e) => {
                        const value = e.target.value;
                        elem.filters[0].value = `${value}#${filterBetween[1] || ""}`;
                        handleChange(e, attributeName, JSON.stringify(parsedConditions));
                    }}
                />
                <TextInput
                    className={styles["input"]}
                    name={i18n`Condition To`}
                    placeholder={i18n`Enter a Condition To`}
                    value={filterBetween[1] || ""}
                    required
                    onChange={(e) => {
                        const value = e.target.value;
                        elem.filters[0].value = `${filterBetween[0] || ""}#${value}`;
                        handleChange(e, attributeName, JSON.stringify(parsedConditions));
                    }}
                />
            </>
        );
    };

    const negationContainer = () => {
        return (
            <div className={styles["condition-container"]}>
                <div className={styles["title-close"]}>
                    <TextInput
                        className={styles["input"]}
                        name={i18n`Remaining Condition Name`}
                        placeholder={i18n`Enter a Condition Name`}
                        value={negationName || ""}
                        onChange={(e) => {
                            setNegationName(e.target.value);
                        }}
                    />
                    <div>
                        <button
                            type="button"
                            className={styles["remove-button"]}
                            onClick={() => {
                                setShowNegationContainer(false);
                                setNegationName("");
                            }}
                        >
                            <Icon name="remove" />
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const buildConditionsFieldsItems = () => {
        return parsedConditionFields.map((item, index) => {
            return (
                <div key={index} className={styles["condition-field"]}>
                    <div key={"item" + index}>
                        <TextInput
                            className={styles["input"]}
                            placeholder={i18n`Enter a value`}
                            value={item || ""}
                            required
                            onChange={(e) => {
                                const _condField = parsedConditionFields;
                                delete _condField[index];
                                _condField[index] = e.target.value || "";
                                handleChange(
                                    e,
                                    "Metadata",
                                    metadataStringify(columnsConfiguration, [..._condField]),
                                );
                            }}
                        />
                    </div>
                    <div className={styles["remove-button-container"]}>
                        <button
                            type="button"
                            className={styles["remove-button"]}
                            onClick={(e) => {
                                let _condField = parsedConditionFields;
                                _condField = _condField.filter((elm, fIndex) => fIndex !== index);

                                handleChange(
                                    e,
                                    "Metadata",
                                    metadataStringify(columnsConfiguration, [..._condField]),
                                );
                            }}
                        >
                            <Icon name="remove" />
                        </button>
                    </div>
                </div>
            );
        });
    };

    const conditionsFielsContainer = () => {
        return (
            <>
                <div className={styles["group-content"]}>
                    <div className={styles["input-field"]}>
                        <h5
                            className={`${styles["label"]} ${styles["no-bottom-margin"]}`}
                        >{i18n`Fields available for criteria`}</h5>
                        <div>
                            {parsedConditionFields && parsedConditionFields.length ? (
                                <div className={styles["command-content-entry"]}>
                                    {buildConditionsFieldsItems()}
                                </div>
                            ) : (
                                <small>{i18n`No field assigned`}</small>
                            )}
                        </div>
                        <div>
                            <button
                                className={styles["add-button"]}
                                type="button"
                                onClick={(e) => {
                                    handleChange(
                                        e,
                                        "Metadata",
                                        metadataStringify(columnsConfiguration, [
                                            ...parsedConditionFields,
                                            "",
                                        ]),
                                    );
                                }}
                            >
                                <small>{i18n`[+] Add another field`}</small>
                            </button>
                        </div>
                    </div>
                </div>
            </>
        )
    };

    const conditionsFilters = parsedConditionsIsArray
        ? (parsedConditions || []).map((elem, i) => {
            const keys = Object.keys(elem);
            const conditionName = keys[0];
            const conditions = elem[conditionName] || [];
            const currentCondition = parsedConditions[i];
            // this is the part you set the condition, it has has the column, operator and value.
            const filtersConditions = conditions.map((condition, index) => {
                const cdmColumn = condition.cdmColumn;
                const operator = condition.operator;
                const filterValue = condition.filters[0] ? condition.filters[0].value : "";
                return (
                    <div key={index} className={styles["condition-entry"]}>
                        <div>
                            <h5 className={styles["label"]}>{i18n`Column`}</h5>
                            <Dropdown
                                className={styles["dropdown"]}
                                placeholder={""}
                                value={conditionsFields.find(({ id }) => id === cdmColumn)}
                                options={conditionsFields}
                                required
                                onChange={(e) => {
                                    currentCondition[conditionName][index].cdmColumn =
                                        e.target.value.id || "";
                                    handleChange(
                                        e,
                                        attributeName,
                                        JSON.stringify(parsedConditions),
                                    );
                                }}
                            />
                        </div>
                        <div>
                            <h5 className={styles["label"]}>{i18n`Operator`}</h5>
                            <Dropdown
                                className={styles["dropdown"]}
                                placeholder={""}
                                value={operator || "equals"}
                                required
                                options={filterOperators}
                                onChange={(e) => {
                                    currentCondition[conditionName][index].operator =
                                        e.target.value.id || "";
                                    handleChange(
                                        e,
                                        attributeName,
                                        JSON.stringify(parsedConditions),
                                    );
                                }}
                            />
                        </div>
                        <div>
                            {operator === "between" || operator === "not between" ? (
                                betweenOperatorInputs(
                                    filterValue,
                                    currentCondition[conditionName][index],
                                )
                            ) : (
                                <TextInput
                                    className={styles["input"]}
                                    name={i18n`Condition`}
                                    placeholder={i18n`Enter a Condition`}
                                    value={filterValue || ""}
                                    required
                                    onChange={(e) => {
                                        currentCondition[conditionName][index].filters[0].value =
                                            e.target.value || "";
                                        handleChange(
                                            e,
                                            attributeName,
                                            JSON.stringify(parsedConditions),
                                        );
                                    }}
                                />
                            )}
                        </div>
                        <div className={styles["remove-button-container"]}>
                            <button
                                type="button"
                                className={styles["remove-button"]}
                                onClick={(e) => {
                                    currentCondition[conditionName].splice(index, 1);
                                    handleChange(
                                        e,
                                        attributeName,
                                        JSON.stringify(parsedConditions),
                                    );
                                }}
                            >
                                <Icon name="remove" />
                            </button>
                        </div>
                    </div>
                );
            });
            return (
                <div key={i} className={styles["condition-container"]}>
                    <div className={styles["title-close"]}>
                        <TextInput
                            className={styles["input"]}
                            name={i18n`${isToKeepOldLabes?"Condition":"Criteria"} Name`}
                            placeholder={i18n`Enter ${isToKeepOldLabes?"a Condition":"criteria's"} name`}
                            value={conditionName || ""}
                            required
                            onChange={(e) => {
                                const currentConfigByIndex = parsedConditions[i][conditionName];
                                const newObject = {};
                                newObject[`${e.target.value}`] = currentConfigByIndex;
                                parsedConditions[i] = newObject;
                                handleChange(
                                    e,
                                    attributeName,
                                    JSON.stringify(parsedConditions),
                                );
                            }}
                        />
                        <div>
                            <button
                                type="button"
                                className={styles["remove-button"]}
                                onClick={(e) => {
                                    parsedConditions.splice(i, 1);
                                    handleChange(
                                        e,
                                        attributeName,
                                        JSON.stringify(parsedConditions),
                                    );
                                }}
                            >
                                <Icon name="remove" />
                            </button>
                        </div>
                    </div>
                    {filtersConditions}
                    <div className={styles["button-and"]}>
                        <RegularButton
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const newCondition = {
                                    column: "",
                                    filters: [
                                        {
                                            value: "",
                                        },
                                    ],
                                    operator: "",
                                    cdmColumn: "",
                                };
                                currentCondition[conditionName].push(newCondition);
                                handleChange(
                                    e,
                                    attributeName,
                                    JSON.stringify(parsedConditions),
                                );
                            }}
                        >{i18n`AND`}</RegularButton>
                    </div>
                </div>
            );
        })
        : [];

    useMemo(() => {
        if (Metadata) {
            const _metadata = parseJson(Metadata);
            setColumnsConfiguration(_metadata?.columnsConfiguration);
            setParsedConditionFields(_metadata?.availableConditionsFields);
        } else {
            setColumnsConfiguration([]);
            setParsedConditionFields([]);
        }
    }, [Metadata]);

    return (
        <>
            {isToShowConditionsFieldds ? conditionsFielsContainer() : null}

            <div className={styles["input-field"]}>
                <h5 className={styles["label"]}>{i18n`${isToKeepOldLabes?"Conditions":"Default criterias"}`}</h5>
                <div>
                    {conditionsFilters.length ? (
                        conditionsFilters
                    ) : (
                        <small>{i18n`No ${isToKeepOldLabes?"conditions":"criteria"} assigned`}</small>
                    )}

                    {showNegationContainer && parsedConditions.length ? negationContainer() : null}
                </div>

                <div className={styles["button-container"]}>
                    <button
                        className={styles["add-button"]}
                        type="button"
                        onClick={(e) => {
                            const defaultObject = {
                                "": [
                                    {
                                        column: "",
                                        filters: [
                                            {
                                                value: "",
                                            },
                                        ],
                                        operator: "",
                                        cdmColumn: "",
                                    },
                                ],
                            };
                            if (!parsedConditionsIsArray) {
                                parsedConditions = [];
                            }

                            parsedConditions.push(defaultObject);
                            handleChange(e, attributeName, JSON.stringify(parsedConditions));
                        }}
                    >
                        <small>{i18n`[+] Add ${isToKeepOldLabes?"new condition":"another criteria"}`}</small>
                    </button>
                </div>

                {isToShowNegation && !showNegationContainer && conditionsFilters.length ? (
                    <div className={styles["button-container"]}>
                        <button
                            className={styles["add-button"]}
                            type="button"
                            onClick={(e) => {
                                setShowNegationContainer(true);
                            }}
                        >
                            <small>{i18n`[+] Add Remaining condition`}</small>
                        </button>
                    </div>
                ) : null}

            </div>
        </>
    );
};

export default CustomReportCondition;